import React from 'react';
import './RowMobile.scss';
import { ICONS } from '../../../constants/icons';
import { useDataLayerValue } from '../../../DataLayer';

function RowMoblie(props) {
    const [{ song_playing, playing, lang }] = useDataLayerValue();
    const changePlaySong = () => {
        props.handleChangePlaySong(props.item.id);
    };
    const changeSelect = () => {
        const idSongSelect = props.ariaSelected === props.item.id ? '' : props.item.id;
        props.handleSelected(idSongSelect);
    };
    return (
        <div className={props.ariaSelected === props.item.id ? "playlist-table--row--mobile aria-selected " : "playlist-table--row--mobile"} onClick={changeSelect} onDoubleClick={changePlaySong}>
            <div className={(song_playing.id === props.item.id) ? "column-1 column-active" : "column-1"}>
                {
                    (song_playing.id === props.item.id) && playing ? (<img src={ICONS.equaliserAnimatedGreen} alt="Animated Play" width="14" height="14" className="img-animated-play" />) : (<span>{props.index}</span>)
                }
                <button className="icon-btn-play" aria-label={props.song} onClick={changePlaySong}>
                    {(song_playing.id === props.item.id) && playing ?
                        (<svg height="16" role="img" width="16" viewBox="0 0 24 24" >
                            <rect x="5" y="3" width="4" height="18" fill="currentColor"></rect>
                            <rect x="15" y="3" width="4" height="18" fill="currentColor"></rect>
                        </svg>) :
                        (<svg height="16" role="img" width="16" viewBox="0 0 24 24">
                            <polygon points="21.57 12 5.98 3 5.98 21 21.57 12" fill="currentColor"></polygon>
                        </svg>)}
                </button>
            </div>
            <div className="column-2">
                <div className="column-img"><img src={props.item.avatar ? props.item.avatar : ''} alt="avatar" /></div>
                <div className={(song_playing.id === props.item.id) ? "column-title column-active" : "column-title"}>{lang === 'en' ? props.item.name_en : props.item.name_vi} <div className="column-singer">{props.item.singer}</div></div>
            </div>

        </div>
    );
}

export default RowMoblie;